import { Suspense, lazy } from 'react';
import { isChartSpecEmpty, type ChartSpec } from '@/lib/chart-config';

// The ECharts runtime (~120 kB gzip) rides an async chunk loaded the first
// time a chart actually renders — report pages pay for it, the rest of the
// app doesn't. The shared option-builder core stays in the main bundle (it is
// pure data logic, imported by the editor too).
const ChartRendererInner = lazy(() => import('./ChartRendererInner'));

interface ChartRendererProps {
    /** Fully-resolved chart spec (from `resolveChartSpec`). */
    spec: ChartSpec | null;
}

/**
 * Lazy shell around the real renderer (`ChartRendererInner`). The chart block
 * container has a fixed height (h-[340px] in the preview, intrinsic size in
 * the A4 measurer), so the null fallback during the one-time chunk load never
 * shifts layout.
 */
export default function ChartRenderer({ spec }: ChartRendererProps) {
    if (!spec || isChartSpecEmpty(spec)) return null;
    return (
        <Suspense fallback={null}>
            <ChartRendererInner spec={spec} />
        </Suspense>
    );
}
